// extracted by mini-css-extract-plugin
export default {"map":"_1nLA65xsTf","click":"_1lZRrcQFye","container":"_3DtcfXEZSR","widget":"_2utLYPn5dk"};
    if(module.hot) {
      // 1625219515013
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  